// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"vy-z","expressButtonContainerWithPayPal":"wy-z","expressButton":"xy-z","or":"yy-z"};